import { BehaviorSubject } from "rxjs";
import { MenuItemType } from "../../data/menuData/menuData";

export interface ContentDisplayRX{
    testMessage:string    
    menuItemType:MenuItemType,
    menuItemRef:string
}


var initialPanelStates:ContentDisplayRX={
    testMessage:'Initial Panel States Applied',
    menuItemType:MenuItemType.NONE,
    menuItemRef:''
}

/**
The subject is converted to an Observable when a subscriber pre-filters the pipe.
In order to set state back into this, a subject would need to be subscribed raw and a next call made
 */
export const landingContentPresenter$ = new BehaviorSubject<ContentDisplayRX>(initialPanelStates);

landingContentPresenter$.subscribe(
    (data)=> {
        testStateInstruction(data);
    }
)

function testStateInstruction(output:ContentDisplayRX){
    //ConsoleOutRXMessageSource("App Presentation State output => " +  output.testMessage);
}





export async function changeLandingContentView(    
    menuItemType:MenuItemType,
    menuItemRef:string
):Promise<ContentDisplayRX>{
    var returnState:ContentDisplayRX = {
        testMessage:'Updated Landing Content View State => ' + MenuItemType[menuItemType].toString(),
        menuItemType:menuItemType,
        menuItemRef:menuItemRef
    }

    landingContentPresenter$.next(returnState);

    return returnState;
}
